// String-valued so enum members are literally `'STAFF'` / `'PARENT'`. The
// cross-tab logout signal (`broadcastLogout`/`syncLogout` in auth.service)
// reads these values back out of localStorage and matches them with
// `String.startsWith`, so the runtime representation must stay these exact
// strings; switching to a numeric enum would break that channel silently.
export enum SessionType {
  STAFF = 'STAFF',
  PARENT = 'PARENT'
}
